module.exports = {
   sign_out: 'Sign Out',
   brand: 'RUBiS',
   selection_error: 'Selection Error',
   selection_error_empty: 'Select a record to continue',
   selection_error_multiple: 'This action only supports one operation at a time',
   copyright: `${new Date().getFullYear()} All rights reserved.`,
}